import { render, staticRenderFns } from "./LanghamConnected.vue?vue&type=template&id=453a354c&scoped=true&"
import script from "./LanghamConnected.vue?vue&type=script&lang=js&"
export * from "./LanghamConnected.vue?vue&type=script&lang=js&"
import style0 from "./LanghamConnected.vue?vue&type=style&index=0&id=453a354c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a354c",
  null
  
)

export default component.exports